import { render, staticRenderFns } from "./HomePageManage.vue?vue&type=template&id=20ff6f76&scoped=true"
import script from "./HomePageManage.vue?vue&type=script&lang=js"
export * from "./HomePageManage.vue?vue&type=script&lang=js"
import style0 from "./HomePageManage.vue?vue&type=style&index=0&id=20ff6f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff6f76",
  null
  
)

export default component.exports